module.exports = __webpack_public_path__ + "static/media/dropdown.e44d5485.svg";